import { render } from "./HendricksHoldings.vue?vue&type=template&id=10c0f586&scoped=true"
import script from "./HendricksHoldings.vue?vue&type=script&lang=js"
export * from "./HendricksHoldings.vue?vue&type=script&lang=js"

import "./HendricksHoldings.vue?vue&type=style&index=0&id=10c0f586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c0f586"]])

export default __exports__